export default __webpack_public_path__ + "static/media/NOC Certificate 3.128bec30.pdf";